// Mirrors the guard in pca-ui/src/lambda/swap.js, which remains the authority.
// Only a plain two-speaker Agent/Customer call can be flipped by exchanging the
// two labels: Genesys calls carry the agent's name or extra IVR/agent labels,
// and an assessed call's published score must not be re-run underneath it.
export function canSwapSpeakers(analytics) {
  if (!analytics || analytics.AssessDetails?.assessed) return false;

  const labels = analytics.SpeakerLabels || [];
  const names = labels.map((l) => String(l.DisplayText || '').toLowerCase()).sort();
  return labels.length === 2 && names[0] === 'agent' && names[1] === 'customer';
}

const GENERIC_ERROR = 'Unable to swap speakers. Please try again.';

export function swapErrorMessage(err) {
  try {
    const parsed = JSON.parse(err?.body || '');
    return parsed?.error || GENERIC_ERROR;
  } catch (_) {
    return GENERIC_ERROR;
  }
}

export function swapSuccessMessage(result) {
  if (!result?.rescoreStarted) {
    return 'Speakers swapped, but re-scoring could not be started. Press Refresh Call to re-score this call.';
  }
  if (result.rescored === 'summary') {
    return 'Speakers swapped. The call summary is being regenerated and will update shortly.';
  }
  return 'Speakers swapped. Re-scoring started, the scores will update shortly.';
}
